module.exports = __webpack_public_path__ + "static/img/OtherP.28c824a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/OtherP.svg
// module id = PYyF
// module chunks = 3